import { mapActions, mapState } from 'vuex';

const DISABLED_GROUPS = [
  'insights',
];


export default {
  metaInfo() {
    return {
      title: 'Site Map',
    };
  },
  computed: {
    ...mapState('about', ['sitemap']),
    filteredGroups() {
      return this.sitemap.groups.filter(group => !DISABLED_GROUPS.includes(group.name.toLowerCase()))
    },
  },
  methods: {
    ...mapActions('about', ['getSitemap']),
  },
  created() {
    this.getSitemap();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-sitemap/page-sitemap.js